import { api } from '../api';
import type { SpecialQualifyingStatus } from './storeSpecial.types';

export interface SpecialQualifyingStatusProps {
  cartUuid?: string;
  specialId?: string | number;
  storeId?: string | number;
  userGroupSpecialId?: string | number;
}

const storeSpecialQualifyingStatusUrls = {
  qualifyingStatus: (props: SpecialQualifyingStatusProps) =>
    `/v1/stores/${props.storeId}/specials/${props.specialId}/qualifying_status/${props.cartUuid}${props.userGroupSpecialId ? `?group_special_id=${props.userGroupSpecialId}` : ''}`,
};

export const fetchSpecialQualifyingStatus = async (
  props: SpecialQualifyingStatusProps
) => {
  const url = storeSpecialQualifyingStatusUrls.qualifyingStatus(props);

  return api.get<SpecialQualifyingStatus>(url);
};
